import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfService} from '../../conf.service';
import {KongService} from '../../kong.service';
import {MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {Loggedin} from '../../authFilter/platformCentralAuth';
import {environment} from '../../../environments/environment';
import * as CryptoJS from 'crypto-js';

@Component({
    selector: 'app-reset-password-dialog',
    templateUrl: './reset-password-dialog.component.html',
    styleUrls: ['./reset-password-dialog.component.scss']
})
export class ResetPasswordDialogComponent implements OnInit {
    password: any;
    cnfPassword: any;
    shash: any;
    ralam: any;
    encyptedPassword: any;

    constructor(private kongService: KongService, private confPost: ConfService, private _snackBar: MatSnackBar, public dialog: MatDialog, public _service: ConnecttocrudService,
                public platform: LeftpanelComponent, public dialogRef: MatDialogRef<ResetPasswordDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
    }

    resetPassword() {
        if ((this.password === this.cnfPassword) && this.password !== '') {
            this.platform.passwordPolicyValidator(this.password).then(status => {
                if (status) {
                    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                        maxWidth: '95vw',
                        maxHeight: '60vh',
                    });
                    this.encyrptUser(this.password);
                    /*this._service.getItemswithParameter('v1', 'access', 'access', 'users', 'id=' + this.data['user']['id']).subscribe(data => {

                        data[0]['environments'][this.data['environementIndex']]['password'] = this.password;
                        data[0]['environments'][this.data['environementIndex']]['shash'] = this.shash;
                        data[0]['environments'][this.data['environementIndex']]['ralam'] = this.ralam;
                        this._service.patchItemUpdate(data[0]['id'], {environments: data[0]['environments']}, 'v1', 'access', 'access', 'users').subscribe(res => {
                            if (res) {
                                loaderDialog.close();
                                this.dialogRef.close('success');
                            }
                        });
                    });*/
                    const resetPasswordPayload = {
                        emailId: this.data['user']['email'],
                        environmentsString: this.data['user']['environments'][this.data['environementIndex']]['name'],
                        password: this.encyptedPassword,
                        shash: this.shash,
                        ralam: this.ralam
                    };
                    this.confPost.passwordComplete(resetPasswordPayload).subscribe(data => {
                        this.platform.openSnackBar('Password has been reset successfully', 'Success', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        loaderDialog.close();
                        this.dialogRef.close('success');
                    }, error => {
                        this.platform.openSnackBar((error.text ? error .text : error.message), '', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        loaderDialog.close();
                        this.dialogRef.close();
                    });
                } else {
                    this.platform.openSnackBar(' Please make sure that your password follows our password policy ', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            });
        } else {
            this.platform.openSnackBar(' Passwords do not match ', 'Error', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    encyrptUser(password) {
        const iterationCount = 1000;
        let keySize = 128;
        keySize = keySize / 32;
        const passphrase = environment.cipheringPhrase;
        const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
        const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
        const cipherText = this.platform.encrypt(salt, iv, passphrase, this.password, keySize, iterationCount);
        this.shash = salt;
        this.ralam = iv;
        this.encyptedPassword = cipherText;
    }

    closeDialog(){
        this.dialogRef.close();
    }
}
